import { configureStore } from "@reduxjs/toolkit";
import reducer from "./store/reducer";
import { apiSlice } from "./api/apiSlice";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

const rootReducer = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(
        createStateSyncMiddleware({
          channel: "stateSyncChannel",
          whitelist: [
            "collapsed/toggle",
            "auth/setLoggedOut",
            "auth/setLoggedIn",
          ],
        })
      ),
  // devTools: true
});

export default rootReducer;
